import React, { memo } from 'react';

import { Checkbox, SubmissionButtons } from '@components/common';
import SpinnerOverlay from '@components/common/SpinnerOverlay';

import { useQueryPreviewConfigFile } from '@hooks/crowdCells/useQueryPreviewConfigFile';

import { IGNodeBConfigParameterWithComment } from '@interfaces/crowdcell/gNodeBConfig';

import { EGNodeBParametersTypes } from '@enums/crowdCells';

import styles from './PreviewConfigFile.module.scss';

interface IPreviewConfigFileProps {
	onClose: () => void;
	onSave: () => void;
	crowdCellId: string;
	isRestartChecked: boolean;
	parameters: IGNodeBConfigParameterWithComment[];
	frequency: string;
}

const PreviewConfigFile = ({
	onClose,
	onSave,
	crowdCellId,
	isRestartChecked,
	parameters,
	frequency,
}: IPreviewConfigFileProps) => {
	const { text, isLoadingPreviewConfigFile } = useQueryPreviewConfigFile({
		id: crowdCellId,
		isRestart: isRestartChecked,
		frequency,
		parameters,
		type: EGNodeBParametersTypes.gnodeb,
	});

	return (
		isLoadingPreviewConfigFile
			? <SpinnerOverlay />
			: <div className={styles.previewContainer}>
				<Checkbox
					checked={isRestartChecked}
					disabled
					label='Restart mobile_service.sh'
					name='isRestartPreview'
				/>
				<div className={styles.textContainer}>
					{text}
				</div>
				<SubmissionButtons
					negativeHandler={onClose}
					negativeLabel='Back'
					positiveHandler={onSave}
					positiveLabel='Save configuration'
				/>
			</div>
	);
};

export default memo(PreviewConfigFile);
